// Custom script to modify URL when variant is selected
document.addEventListener("DOMContentLoaded", function () {
  // Find the product-info element
  const productInfo = document.querySelector("product-info");

  if (productInfo) {
    // Override the updateURL method
    const originalUpdateURL = productInfo.updateURL;
    productInfo.updateURL = function (url, variantId) {
      // Get the variant selects element
      const variantSelects = document.querySelector("variant-selects");

      if (variantSelects && variantId) {
        // Get the selected variant data
        const selectedVariantData = JSON.parse(
          variantSelects.querySelector("[data-selected-variant]").innerHTML
        );

        // Get the product options to determine which option is size and which is color
        const optionElements = variantSelects.querySelectorAll(
          ".product-form__input fieldset legend"
        );
        let size = "";
        let color = "";

        // Map option positions (1, 2, 3) to their actual values (size or color)
        for (let i = 0; i < optionElements.length; i++) {
          const optionName = optionElements[i].textContent.trim().toLowerCase();
          const optionPosition = i + 1; // Option positions are 1-indexed in Shopify
          const optionValue = selectedVariantData["option" + optionPosition];

          if (optionName.includes("size")) {
            size = optionValue;
          } else if (
            optionName.includes("color") ||
            optionName.includes("colour")
          ) {
            color = optionValue;
          }
        }

        // Create the URL with variant ID, size, and color
        const newUrl = `${url}?variant=${variantId}&size=${encodeURIComponent(
          size
        )}&color=${encodeURIComponent(color)}`;

        // Update the share button URL if it exists
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${newUrl}`
        );

        // Update the browser URL
        if (this.dataset.updateUrl !== "false") {
          window.history.replaceState({}, "", newUrl);
        }
      } else {
        // If no variant is selected or variant selects not found, use the original method
        originalUpdateURL.call(this, url, variantId);
      }
    };
  }
});
